export default class Locale_CustomProperty {
	InternalName: string = "Internal name";
	Group: string = "Group";
	EditableBy: string = "Editable by";
}